import SideBarContainer from 'Containers/SideBarContainer';
import ReportsLayout from 'Pages/reports/components/ReportsLayout/ReportsLayout';
import useCoursesReportPage from './hooks/useCoursesReportPage';
import ReportsTitle from 'Pages/reports/components/ReportsTitle/ReportsTitle';
import { Padding } from 'Components/Padding';
import CoursesReportsFilters from './components/CoursesReportFilters/CoursesReportFilters';
import GenericTable from '../employees/components/GenericTable/GenericTable';
import ProgressIndicator from 'Components/ProgressIndicator';
import type { CourseReportRowI } from 'types';
import { useHistory } from 'react-router-dom';
import GenericTableText from 'Components/GenericTableText/GenericTableText';
import { buildTime } from 'Pages/reports/utils/buildTime';
import { FaPeopleGroup } from 'react-icons/fa6';
import { MdSchool } from 'react-icons/md';

export default function Page() {
  const history = useHistory();
  const { t2, onSearch, coursesReportData, onExport } = useCoursesReportPage();

  const buttons = [
    { icon: <FaPeopleGroup size={24} />, tooltip: t2('employees_report_tooltip'), route: '/reporte/empleados' },
    { icon: <MdSchool size={24} />, tooltip: t2('courses_report_tooltip'), route: '/reporte/cursos' },
  ];

  return (
    <SideBarContainer>
      <ReportsLayout
        title={<ReportsTitle title={t2('title')} accent={t2('title_accent')} />}
        buttons={buttons}
        onExport={onExport}
      />
      <Padding padding="1rem">
        <CoursesReportsFilters onSearch={onSearch} />
        <Padding padding="1rem 0" />
        <GenericTable<CourseReportRowI>
          columns={[
            { id: 'name', label: t2('name') },
            { id: 'priority', label: t2('priority') },
            { id: 'totalEmployees', label: t2('total_employees'), align: 'center' },
            { id: 'category', label: t2('category') },
            { id: 'progress', label: t2('progress'), align: 'center' },
            { id: 'trainingHours', label: t2('training_hours'), align: 'center' },
          ]}
          rows={coursesReportData.map(course => ({
            id: course.id,
            name: course.name,
            priority: course.priority,
            totalEmployees: course.totalUsers,
            category: course.category,
            progress: (
              <ProgressIndicator
                completed={course.totalUsersCompleted}
                total={course.totalUsers}
                emptyMessage={t2('no_progress')}
              />
            ),
            trainingHours: course.trainingHours ? (
              buildTime(course.trainingHours, t2)
            ) : (
              <GenericTableText text={t2('no_training_hours')} />
            ),
          }))}
          onRowClick={row => {
            history.push(`/reporte/cursos/${row.id}`);
          }}
        />
      </Padding>
    </SideBarContainer>
  );
}
